import * as React from 'react';
import { IProductInfoContentViewProps } from './product-info-content';
import { Module } from '@msdyn365-commerce-modules/utilities';

export default (props: IProductInfoContentViewProps) => {
    const { content, Container } = props;

    return <Module {...Container}>{content}</Module>;
};
